// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.

import { secrets } from "./secrets";

// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: true,
  // API_URL:"http://localhost:3301",
  API_URL: "https://dev-backend.osmosapp.com",
  ITEM_MODULE_URL:"https://dev.osmosapp.com/core_management",
  USER_MANAGEMENT_URL:"https://dev.osmosapp.com/user_management",
  QUOTE_MANAGEMENT_URL: 'https://dev.osmosapp.com/quotes_management',
  QUOTE_SOCKET_URL: 'https://dev.osmosapp.com',
  ORG_MODULE_URL:"https://dev.osmosapp.com/core_management",
  MAILBOX_MANAGEMENT_URL:"https://dev.osmosapp.com/core_management",
  AGENDA_MANAGEMENT_URL:"https://dev.osmosapp.com/core_management",
  WEBSITE_URL: "https://dev-frontend.osmosapp.com",
  LEAD_MANAGEMENT_URL: "https://dev.osmosapp.com/core_management",
  STRIPE_PUBLIC_KEY: "pk_test_51IxYZoBuv0ATMfMv66tUdi3DknArhNt0xnEhav5qk2uk2zrwZPW7UnhGIDEewVFZabXTbv950WqBsQxEC5zzDNtk00LBrLjMz6",
  IMAGE_BACKET_URL: 'https://osmos-v2-images-2026.s3.us-west-2.amazonaws.com/osmos-v2-images/',
  AUTOMATION_MANAGEMENT_URL:"https://dev.osmosapp.com/core_management",
  recaptcha: {
    siteKey: '6Lf20E4qAAAAALjC5-e_yBKiG0IjlB0LG7bJdhap'
  },
  turnstile: {
    siteKey: '0x4AAAAAADJjYXurYzOTV7CZ',
    /** Set true locally to POST dummy tokens to verify endpoint (do not enable in prod). */
    forceVerifyHttp: false,
  },
    WIDGET_PUBLIC_KEY: 'XiRMzMcEUVzbdsR3aig2NAQz8GHrhMGKLNQv6uNiWQxJzeYEzFrb7MtKyemMfNa7',
  ...secrets

};